import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { orderCategoryDetail, orderExceptionCategoryDetail } from '@/views/platformReport/api/index.js';
import cityDetailStatistics from '@/views/platformReport/components/cityDetailStatistics.vue';
import provinceDetailStatistics from '@/views/platformReport/components/provinceDetailStatistics.vue';
export default {
  components: {
    cityDetailStatistics: cityDetailStatistics,
    provinceDetailStatistics: provinceDetailStatistics
  },
  props: {
    /**
     * entry 入口类型
     * platformReport - 平台报表-订单消费统计
     * abnormalOrderMonitor - 平台报表-异常订单监控
     * orderListDetail - 订单列表-订单详情
    */
    entry: {
      type: String,
      default: function _default() {
        return 'platformReport';
      }
    },
    /**
     * originParams 原始参数
    */
    originParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      tabsName: '1',
      tabsConfig: [{
        name: '1',
        label: '品牌明细',
        tips: '以品牌为单位汇总统计通过当前菜单生成的订单数、消费点数、成本'
      }, {
        name: '3',
        label: '下单省份',
        tips: '以用户购买商品/服务所在省份为单位，汇总通过当前菜单生成的订单数、消费点数、消费占比、成本、成本率'
      }, {
        name: '2',
        label: '下单城市',
        tips: '以用户购买商品/服务所在城市为单位，汇总通过当前菜单生成的订单数、消费点数、消费占比、成本、成本率'
      }],
      headerCellStyle: {
        background: '#F1F1F1',
        color: '#333333'
      },
      list: [],
      pages: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      }
    };
  },
  mounted: function mounted() {
    this.handleResetData();
    this.handleGetBrandDetailList();
  },
  methods: {
    rowStyle: function rowStyle(_ref) {
      var row = _ref.row;
      if (['合计', '总计'].includes(row.brand_name)) {
        return {
          fontWeight: 'bold',
          color: '#000'
        };
      } else {
        return {};
      }
    },
    handleResetData: function handleResetData() {
      this.tabsName = '1';
      this.pages.page = 1;
      this.pages.pagesize = 50;
      this.pages.totalCount = 0;
      this.list = [];
    },
    handleClickTab: function handleClickTab(tab) {
      var _this = this;
      if (tab.name === '1') {
        // 品牌明细
        this.pages.page = 1;
        this.handleGetBrandDetailList();
      } else if (tab.name === '3') {
        // 下单省份
        this.$nextTick(function () {
          _this.$refs.provinceDetailStatistics && _this.$refs.provinceDetailStatistics.refreshData();
        });
      } else if (tab.name === '2') {
        // 下单城市
        this.$nextTick(function () {
          _this.$refs.cityDetailStatistics && _this.$refs.cityDetailStatistics.refreshData();
        });
      }
    },
    // 下单省份 - 点击省份跳转到下单城市
    onJumpCityStatistics: function onJumpCityStatistics(provinceCode) {
      var _this2 = this;
      this.tabsName = '2';
      this.$nextTick(function () {
        _this2.$refs.cityDetailStatistics && _this2.$refs.cityDetailStatistics.jumpWithProvince(provinceCode);
      });
    },
    handleGetBrandDetailList: function handleGetBrandDetailList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (_this3.entry === 'platformReport') {
                // 平台报表-订单消费统计
                _this3.getPlatformList();
              } else if (_this3.entry === 'abnormalOrderMonitor') {
                // 异常订单监控
                _this3.getAbnormalList();
              } else if (_this3.entry === 'orderListDetail') {
                // 订单列表-订单详情
                _this3.getOrderListDetailList();
              }
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handlePageChange: function handlePageChange(page) {
      this.pages.page = page;
      this.handleGetBrandDetailList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pages.pagesize = size;
      this.pages.page = 1;
      this.handleGetBrandDetailList();
    },
    // 平台报表 - 订单消费统计 - 商城菜单统计 - 明细
    getPlatformList: function getPlatformList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _ref2, order_id, category_id, order_type, _ref3, page, pagesize, params, _yield$orderCategoryD, data, pages, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _ref2 = _this4.originParams || {}, order_id = _ref2.order_id, category_id = _ref2.category_id, order_type = _ref2.type;
              _ref3 = _this4.pages || {}, page = _ref3.page, pagesize = _ref3.pagesize;
              params = {
                order_id: order_id,
                category_id: category_id,
                order_type: order_type,
                page: page,
                pagesize: pagesize
              };
              _context2.n = 1;
              return orderCategoryDetail(params);
            case 1:
              _yield$orderCategoryD = _context2.v;
              data = _yield$orderCategoryD.data;
              pages = _yield$orderCategoryD.pages;
              _this4.pages.totalCount = (pages === null || pages === void 0 ? void 0 : pages.totalCount) || 0;
              _this4.list = (data === null || data === void 0 ? void 0 : data.list) || [];
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
              _this4.list = [];
              _this4.pages.totalCount = 0;
              console.log(_t);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }))();
    },
    // 平台报表 - 异常订单监控 - 商城菜单统计 - 明细
    getAbnormalList: function getAbnormalList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _ref4, order_id, category_id, order_type, _ref5, page, pagesize, params, _yield$orderException, data, pages, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _ref4 = _this5.originParams || {}, order_id = _ref4.order_id, category_id = _ref4.category_id, order_type = _ref4.type;
              _ref5 = _this5.pages || {}, page = _ref5.page, pagesize = _ref5.pagesize;
              params = {
                order_id: order_id,
                category_id: category_id,
                order_type: order_type,
                page: page,
                pagesize: pagesize
              };
              _context3.n = 1;
              return orderExceptionCategoryDetail(params);
            case 1:
              _yield$orderException = _context3.v;
              data = _yield$orderException.data;
              pages = _yield$orderException.pages;
              _this5.pages.totalCount = (pages === null || pages === void 0 ? void 0 : pages.totalCount) || 0;
              _this5.list = (data === null || data === void 0 ? void 0 : data.list) || [];
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t2 = _context3.v;
              _this5.list = [];
              _this5.pages.totalCount = 0;
              console.log(_t2);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }))();
    },
    // 订单列表 - 订单详情 - 商城菜单统计 - 明细(暂与“平台报表-订单消费统计”明细一致，后续可能会有差异)
    getOrderListDetailList: function getOrderListDetailList() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _ref6, order_id, category_id, order_type, _ref7, page, pagesize, params, _yield$orderCategoryD2, data, pages, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _ref6 = _this6.originParams || {}, order_id = _ref6.order_id, category_id = _ref6.category_id, order_type = _ref6.type;
              _ref7 = _this6.pages || {}, page = _ref7.page, pagesize = _ref7.pagesize;
              params = {
                order_id: order_id,
                category_id: category_id,
                order_type: order_type,
                page: page,
                pagesize: pagesize
              };
              _context4.n = 1;
              return orderCategoryDetail(params);
            case 1:
              _yield$orderCategoryD2 = _context4.v;
              data = _yield$orderCategoryD2.data;
              pages = _yield$orderCategoryD2.pages;
              _this6.pages.totalCount = (pages === null || pages === void 0 ? void 0 : pages.totalCount) || 0;
              _this6.list = (data === null || data === void 0 ? void 0 : data.list) || [];
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t3 = _context4.v;
              _this6.list = [];
              _this6.pages.totalCount = 0;
              console.log(_t3);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, null, [[0, 2]]);
      }))();
    }
  }
};